import { BookingStep } from './types';

export const BookingStepViews = {
  Calendar: 'Calendar',
  SlotPicker: 'SlotPicker',
  ParticipantPicker: 'ParticipantPicker',
  GuestForm: 'GuestForm',
  GuestExtra: 'GuestExtra',
  Extra: 'Extra',
} as const;

export type BookingStepView = keyof typeof BookingStepViews;

export const DefaultEventBookingFlow: BookingStepView[] = [
  BookingStepViews.Calendar,
  BookingStepViews.SlotPicker,
  BookingStepViews.GuestExtra,
];

export const FlowWithNoPresetGuestDetailsAndWithPMS: BookingStepView[] = [
  BookingStepViews.Calendar,
  BookingStepViews.SlotPicker,
  BookingStepViews.GuestForm,
  BookingStepViews.Extra,
];
